import { StableName } from '../../utils/racing-game/horses.ts';
import publicAxiosService, {
  getParamsWithDefOnes,
} from './publicAxiosService.ts';
import { HorseName } from '../../utils/racing-game/consts.ts';

type HistoryRoundData = {
  a: {
    [key in '1' | '2' | '3']: HorseName;
  };
  a_mul: null;
  a_data: {
    A: {
      1: {
        1: number; // 8.75
        2: number; // 1.25
        3: number; // 5
      };
      2: {
        1: number; // 0
        2: number; // 0
        3: number; // 0
      };
    };
    B: {
      1: number; // 1.2972972972972974
    };
  };
  b: string; // "B"
  b_mul: null;
  end_at: number;
};

type HistoryData = {
  [key in string]: HistoryRoundData;
};

export const getGameRoundsHistoryDataAPI = async (
  params?: { currency_id?: number } & Record<string, unknown>
) =>
  publicAxiosService.get<undefined, HistoryData>('/game/history', {
    params: getParamsWithDefOnes(params),
  });

type GetAsidesAPIParams = {
  round: string | number;
} & Record<string, unknown>;

export const getGameAsidesAPI = async (params: GetAsidesAPIParams) =>
  publicAxiosService.get<undefined, string[]>(`/game/ads`, {
    params: getParamsWithDefOnes(params),
  });

export type GetGameMultipliersAPIParams = {
  round: string | number;
  currency_id?: number;
} & Record<string, unknown>;

export type GetGameMultipliersAPIResponse =
  | {
      [key in 'a' | 'b' | 'sumA' | 'sumB']: number;
    }
  | ({
      a: {
        [key in HorseName]: number;
      };
      b: {
        [key in StableName]: number;
      };
    } & {
      [key in 'sumA' | 'sumB']: number;
    });

export const getGameMultipliersAPI = async (
  params: GetGameMultipliersAPIParams
) =>
  publicAxiosService.get<undefined, GetGameMultipliersAPIResponse>(
    `/game/multiplier`,
    {
      params: getParamsWithDefOnes(params),
    }
  );

export type PostGameResultReplayBody = {
  round: string;
  transactionid: string;
  hash: string;
  language: string;
};

export type PostGameResultReplayResponse = {
  round: {
    roundid: number;
    start: string; // JSON string
    start_at: string;
    end: string; // JSON string
    end_at: string;
    performance: string; // JSON string
    winnerA: string; // JSON string
    winnerB: string;
    winnerAdata: string; // JSON string
  };
  gamebetuser: {
    transactionid: string;
    gamebetuserid: number;
    bet: string;
    amount: number;
    won: number;
  };
};

export const postGameResultReplayAPI = async (body: PostGameResultReplayBody) => {
  try {
    // Most endpoints in this app are called without the "/api" prefix.
    return await publicAxiosService.post<undefined, PostGameResultReplayResponse>(
      `/game/result`,
      body
    );
  } catch (error) {
    // Fallback for deployments where the backend expects "/api/...".
    const status = (error as { status?: number } | undefined)?.status;
    if (status === 404) {
      return await publicAxiosService.post<
        undefined,
        PostGameResultReplayResponse
      >(`/api/game/result`, body);
    }
    throw error;
  }
};
